export default __webpack_public_path__ + "static/media/notification.618f5c76.mp3";